/* eslint-disable import/prefer-default-export */
export const answerCriteriaTypes = [
  {
    label: '단어포함 (정답: 손흥민 | 허용되는 답: 손흥민 선수)',
    value: 1,
  },
  {
    label: '띄어쓰기 무시 (정답: 이순신장군 | 허용되는 답: 이순신 장군)',
    value: 2,
  },
  {
    label: '대소문자 무시 (정답: Student | 허용되는 답: student)',
    value: 4,
  },
  {
    label: '숫자만 인식 (정답: 10 | 허용되는 답: 10개)',
    value: 8,
  },
  {
    label: '한글/영어/숫자만 인식(특수문자 제거) (정답: 가 자전거 | 허용되는 답: 가: 자전거) ',
    value: 16,
  },
];



// WEBPACK FOOTER //
// ./src/constants/answerCriteria.js